import { render } from "./ChatGPTBotSettings.vue?vue&type=template&id=1cbbe992"
import script from "./ChatGPTBotSettings.vue?vue&type=script&lang=js"
export * from "./ChatGPTBotSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__